module.exports = __webpack_public_path__ + "img/param-2.6b3f92e9.png";